// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3WvZG","image":"Header_image__3S0Z_","name":"Header_name__3UGNU","info":"Header_info__3EnXZ","infoRow":"Header_infoRow__2XSNY"};